import script from "./ImmediateParentLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./ImmediateParentLoader.vue?vue&type=script&setup=true&lang=js"

import "./ImmediateParentLoader.vue?vue&type=style&index=0&id=07aa9f12&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07aa9f12"]])

export default __exports__